import React, {Component} from "react";
import PropTypes from "prop-types";
import styles from "./UserNote.scss";
import classNames from "classnames";
import {_saveUserNotes} from "../../../../../services/apis/AdminUserServices";

class UserNote extends Component {
    state = {
        text: this.props.note,
        status: ''
    };

    _delaySaving = null;

    _saving = () => {
        const {text} = this.state;
        const {userId} = this.props;

        this.setState({
            status: 'Saving...'
        });

        _saveUserNotes({
            userId,
            note: text
        }).then(() => {
            this.setState({
                status: ''
            });

            this.props.onChange();
        });
    };

    _handleChangeText = (e) => {
        const {value} = e.target;

        if (this.state.text === value) {
            return;
        }

        this.setState({
            text: value
        });

        if (this._delaySaving) {
            clearTimeout(this._delaySaving);
        }

        this._delaySaving = setTimeout(() => {
            this._saving();
        }, 1000);
    };

    render() {
        const {text, status} = this.state;

        return (
            <td className={styles.UserNote}>
                <div className="form-group">
                    <div className={styles.note}>
                        <textarea
                            onChange={this._handleChangeText}
                            value={text}
                            className={classNames(styles.input, "form-control")}
                            name="user-note" rows="3"/>
                    </div>

                    <div className={classNames(styles.status, {[styles.active]: !!status})}>{status}</div>
                </div>
            </td>
        );
    }
}

UserNote.propTypes = {
    note: PropTypes.string,
    userId: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default UserNote;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/user/UserNote/UserNote.js